<!-- 车辆记录管理 -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="详细信息"
      :visible.sync="detailVisible"
      width="720px"
      append-to-body
      @closed="detailRow = {}"
    >
      <el-descriptions v-if="detailVisible" :column="2" border size="small">
        <el-descriptions-item label="客户">{{ detailRow.custName || detailRow.custNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="车牌号">{{ detailRow.trainNumber || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计划号">{{ detailRow.planNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计划开始时间">{{ detailFullDateTime(detailRow.planIntervalStartTime) }}</el-descriptions-item>
        <el-descriptions-item label="计划结束时间">{{ detailFullDateTime(detailRow.planIntervalEndTime) }}</el-descriptions-item>
        <el-descriptions-item label="物资">{{ detailRow.cargoName || detailRow.cargoNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="拉运日期">{{ detailHaulDate(detailRow.planIntervalStartTime) }}</el-descriptions-item>
        <el-descriptions-item label="在厂时长">{{ detailPlantStay(detailRow.plantStaySeconds) }}</el-descriptions-item>
        <el-descriptions-item label="进门时间" :span="2">{{ detailFullDateTime(detailRow.ingateTime) }}</el-descriptions-item>
        <el-descriptions-item label="重磅时间" :span="2">{{ detailFullDateTime(detailRow.heavyTime) }}</el-descriptions-item>
        <el-descriptions-item label="空磅时间" :span="2">{{ detailFullDateTime(detailRow.emptyTime) }}</el-descriptions-item>
        <el-descriptions-item label="出门时间" :span="2">{{ detailFullDateTime(detailRow.outgateTime) }}</el-descriptions-item>
        <el-descriptions-item label="皮重(吨)">{{ detailRow.tareWeight != null ? detailRow.tareWeight : '-' }}</el-descriptions-item>
        <el-descriptions-item label="毛重(吨)">{{ detailRow.grossWeight != null ? detailRow.grossWeight : '-' }}</el-descriptions-item>
        <el-descriptions-item label="净重(吨)">{{ detailRow.netWeight != null ? detailRow.netWeight : '-' }}</el-descriptions-item>
        <el-descriptions-item label="司机">{{ detailRow.driverName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailRow.phoneNo || '-' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, exportExcel } from "./api";
import { downloadXls } from '@/util/util'
import { searchTimeConfig } from "@/basic-common/util/common";
import { getSettingDate } from '@/util/date'

/** 在厂时长：plantStaySeconds 为秒 */
function formatPlantStaySeconds(sec) {
  if (sec == null && sec !== 0) return '-'
  const n = Number(sec)
  if (!Number.isFinite(n)) return '-'
  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(Math.trunc(n))
  const h = Math.floor(abs / 3600)
  const m = Math.floor((abs % 3600) / 60)
  const s = abs % 60
  if (h > 0) return `${sign}${h}小时${m}分`
  if (m > 0) return `${sign}${m}分${s}秒`
  return `${sign}${s}秒`
}

/** 解析接口日期时间，得到 { date, time } 或 null */
function parseDateTimeParts(val) {
  if (val == null || val === '') return null
  if (val instanceof Date && !Number.isNaN(val.getTime())) {
    const y = val.getFullYear()
    const mo = String(val.getMonth() + 1).padStart(2, '0')
    const da = String(val.getDate()).padStart(2, '0')
    const h = String(val.getHours()).padStart(2, '0')
    const mi = String(val.getMinutes()).padStart(2, '0')
    const s = String(val.getSeconds()).padStart(2, '0')
    return { date: `${y}-${mo}-${da}`, time: `${h}:${mi}:${s}` }
  }
  const str = String(val).trim()
  const m = str.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})/)
  if (m) return { date: m[1], time: m[2] }
  if (/^\d{13}$/.test(str)) {
    const d = new Date(Number(str))
    if (!Number.isNaN(d.getTime())) return parseDateTimeParts(d)
  }
  const d = new Date(str)
  if (!Number.isNaN(d.getTime())) return parseDateTimeParts(d)
  return null
}

function formatTimeOnly(val) {
  const p = parseDateTimeParts(val)
  return p ? p.time : '-'
}

function formatHaulDate(val) {
  const p = parseDateTimeParts(val)
  return p ? p.date : '-'
}

/** 详情弹窗：完整日期时间 */
function fullDateTimeText(val) {
  if (val == null || val === '') return '-'
  const p = parseDateTimeParts(val)
  if (p) return `${p.date} ${p.time}`
  return String(val)
}

export default {
  mixins: [crudMixins],
  data() {
    return {
      exportLoading: false,
      apiConfig: {getList},
      defaultParams: {
        businessType: "3", //必须传且为3 汽车入库
      },
      detailVisible: false,
      detailRow: {},
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menu: true,
        menuWidth: 90,
        column: [
          {
            label: '拉运日期',
            prop: 'haulDate',
            width: 110,
            formatter: (row) => formatHaulDate(row.planIntervalStartTime),
          },
          {
            label: '计划号',
            prop: 'planNo',
            width: 200,
          },
          {
            label: '计划开始时间',
            prop: 'planIntervalStartTime',
            width: 165,
            formatter: (row) => fullDateTimeText(row.planIntervalStartTime),
          },
          {
            label: '计划结束时间',
            prop: 'planIntervalEndTime',
            width: 165,
            formatter: (row) => fullDateTimeText(row.planIntervalEndTime),
          },
          {
            label: '客户',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
            width: 150,
          },
          {
            label: '车牌号',
            prop: 'trainNumber',
            search: true,
            width: 150,
          },
          {
            label: '司机姓名',
            prop: 'driverName',
            // search: true,
            width: 150,
          },
          {
            label: '司机手机号',
            prop: 'phoneNo',
            // search: true,
            width: 150,
          },
          {
            label: '派车时间',
            prop: 'createTime',
            width: 165,
            formatter: (row) => fullDateTimeText(row.createTime),
          },
          {
            label: '物资名称',
            prop: 'cargoNo',
            type: 'select',
            remote: true,
            search: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'varNo'
            },
            width: 150,
          },
          {
            label: '进门时间',
            prop: 'ingateTime',
            width: 150,
            // formatter: (row) => formatTimeOnly(row.ingateTime),
            formatter: (row) => fullDateTimeText(row.ingateTime),
          },
          {
            label: '重磅时间',
            prop: 'heavyTime',
            // hide: true,
            width: 150,
            // formatter: (row) => formatTimeOnly(row.heavyTime),
            formatter: (row) => fullDateTimeText(row.heavyTime),
          },
          {
            label: '空磅时间',
            prop: 'emptyTime',
            // hide: true,
            width: 150,
            // formatter: (row) => formatTimeOnly(row.emptyTime),
            formatter: (row) => fullDateTimeText(row.emptyTime),
          },
          {
            label: '出门时间',
            prop: 'outgateTime',
            width: 150,
            // formatter: (row) => formatTimeOnly(row.outgateTime),
            formatter: (row) => fullDateTimeText(row.outgateTime),
          },
          {
            label: '皮重(吨)',
            prop: 'tareWeight',
            width: 100,
          },
          {
            label: '毛重(吨)',
            prop: 'grossWeight',
            width: 100,
          },
          {
            label: '净重(吨)',
            prop: 'netWeight',
            width: 100,
          },
          {
            label: '在厂时长',
            prop: 'plantStaySeconds',
            width: 120,
            formatter: (row) => formatPlantStaySeconds(row.plantStaySeconds),
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            /** 默认近 30 天；查询时间与查询/重置布局同 daily-plan-management（searchTimeConfig + queryAutoArrange） */
            searchValue: [getSettingDate('daySLast30'), getSettingDate('dayE')],
          }
        ]
      },
    }
  },
  mounted() {

  },
  methods: {
    /**
     * 导出当前筛选条件下的列表为 Excel（服务端生成，列与表格一致）。
     */
    async handleExport () {
      const total = this.page.total || 0
      if (total < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      const maxRows = 10000
      if (total > maxRows) {
        this.$message.warning(`当前最多导出 ${maxRows} 条，请缩小筛选范围后重试`)
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `车辆进场记录_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    openDetail(row) {
      this.detailRow = row ? { ...row } : {}
      this.detailVisible = true
    },
    detailFullDateTime(val) {
      return fullDateTimeText(val)
    },
    detailHaulDate(val) {
      return formatHaulDate(val)
    },
    detailPlantStay(sec) {
      return formatPlantStaySeconds(sec)
    },
  }
}
</script>
<style scoped lang="scss">

</style>
